var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkypassIconInquiry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 26,
    fill: "url(#pattern0_1457_5624)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1457_5624",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1457_5624",
    transform: "matrix(0.015873 0 0 0.0152625 0 -0.0189255)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1457_5624",
    width: 63,
    height: 68,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAABECAYAAAA2uu3dAAAACXBIWXMAAAsSAAALEgHS3X78AAAB+klEQVR4nOWaTXLCMAyFX5iWK5QTljNxQ87AJt0QJs2YoD9LsvJWDBPL/mT5YQdP8zwju86X62uQj/ttsoo7ZYZfQ29lkYS08Hvga2mScJI27CkqOPfZrdLBS2CkCUgFr5lFSdtU8FpxE5DG8DSz3hLFCFPMPAX8cb9NHGenxAyHp4K3Pmtjh8Jzwfe+k/QRtual4JI472KFl71W1Co4X67zNlEh8FazLnl23bc7vDW4pM0yBlf4XuDStm6G1xtc0p/LzFMd2XKXN8wOby3PBHSH9zyicuN0hfc+onLbd4O3mD1pDKq5doG3dPbWzsyqb3N4TufWR1Suwt3eMgHcijPd5GjLXXNCk/RtBm+9zjmxpH2bwHtvXa36Vq/5UcEBJfzI4IACPhLcSuE/dRJZJV4EP3q5L2LDVwEHmPCVwAEGfDVwgAhfwdlbSu/2PRP/Eb5iuS/aha8MDuzAVwcH3sAfARxowFd19pZSub134v/BH6XcF73gjwYOPOGPCA4A0/fP7yHBAYLhVXH2lsLcPnrWgQ/wVct9UZkLSRKVupDElRt8NnAAOGVx84hxqM/zFPX4b91CKS4kRVVf+IWkyGUXeiEp2m/SX0jqqZP1QEYBB4xeXY+qL8pD3heCveS6vc0EDjjCZwMHnOAzggMr+F4DzAoOJHtv760/htCdoraIuWEAAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkypassIconInquiry);
export default __webpack_public_path__ + "static/media/skypass_icon_inquiry.9ac6a37d349c2a36a4fe306409d76b69.svg";
export { ForwardRef as ReactComponent };